import React from 'react'
import PropTypes from 'prop-types'
import { Skeleton } from '@chilecompra/react-kit/components'
import { Root, Span, Typography } from './Score.styles'

/**
 * The Score' component.
 */
const Score = props => {
  const { color, loading, max, rate, justifyContent } = props

  return (
    <Root justifyContent={justifyContent}>
      <Typography color={color} fontSize="30px" fontWeight="bold" variant="h1">
        {loading ? <Skeleton variant="rect" padding="0 14px" /> : rate}
      </Typography>
      <Typography color={color === 'black1' ? 'black1' : 'black3'} display="flex" fontWeight="bold" variant="h4">
        <Span>/</Span>
        {loading ? <Skeleton variant="rect" padding="0 6px" /> : max}
      </Typography>
    </Root>
  )
}

Score.defaultProps = {
  color: 'primary',
  loading: false
}

Score.propTypes = {
  color: PropTypes.oneOf(['error', 'primary', 'success', 'warning', 'black1', 'black3']),
  loading: PropTypes.bool,
  max: PropTypes.number.isRequired,
  rate: PropTypes.string.isRequired,
  justifyContent: PropTypes.string
}

export default Score
